import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { PrecreditInputComponent } from '../precredit-input/precredit-input.component';
import { SelectorComponent } from '../selectors/simple/selector.component';
import { InputDateComponent } from '../input-date/input-date.component';
import { CheckboxComponent } from '../checkbox/checkbox.component';
import { FormErrorPipe } from 'src/ui/pipes/form-error.pipe';

@Component({
  selector: 'input-generator',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PrecreditInputComponent,
    SelectorComponent,
    InputDateComponent,
    CheckboxComponent,
    FormErrorPipe
],
  templateUrl: './input-generator.component.html',
  styleUrl: './input-generator.component.scss'
})
export class InputGeneratorComponent {
  @Input() label: string = '';
  @Input() dataType: string = 'TEXT';
  @Input() placeholder: string = 'Ingresar';
  @Input() options: string[] = [];
  @Input() control: AbstractControl | null = new FormControl();
  @Input() useOverlayForList: boolean = false;
  @Input() fieldName: string = '';

  checkBoxTouched: boolean = false;

  onCheckboxClick(): void {
    this.checkBoxTouched = true;
    if (this.control) {
      this.control.markAsTouched();
    }
  }

  onCheckboxChange(): void {
    if (this.control) {
      this.control.markAsTouched();
      this.control.updateValueAndValidity();
    }
  }

  getControlName(): string {
    const formControl = this.control as FormControl | null;
    return formControl && formControl.parent
      ? Object.keys(formControl.parent.controls).find(
          name => formControl === formControl.parent!.get(name)
        ) || ''
      : '';
  }

  getFormGroup(): any {
    const formControl = this.control as FormControl | null;
    return formControl ? formControl.parent : null;
  }

  getErrorMessage(): string {
    if (this.control && (this.control.hasError('required') || this.control.hasError('requiredTrue'))) {
      const canonical = this.fieldName.trim().toLowerCase().replace(/\s+/g, '_');
      if (canonical === 'primer_nombre') return 'El Primer Nombre es obligatorio.';
      if (canonical === 'primer_apellido') return 'El Primer Apellido es obligatorio.';
      return 'Este campo es obligatorio.';
    }
    return 'Campo inválido';
  }

  preventEKey(event: KeyboardEvent): void {
    if (event.key === 'e' || event.key === 'E') {
      event.preventDefault();
    }
  }

  isRequired(): boolean {
    if (!this.control || !this.control.validator) {
      return false;
    }
    const validator = this.control.validator({} as AbstractControl);
    return validator && (validator['required'] || validator['requiredTrue']);
  }
}
